import {
  Component,
  ElementRef,
  ViewChild,
  forwardRef,
  AfterViewInit,
  OnInit,
} from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-masked-input-type',
  templateUrl: './masked-input-type.component.html',
  styleUrls: ['./masked-input-type.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MaskedInputTypeComponent),
      multi: true,
    },
  ],
})
export class MaskedInputTypeComponent
  extends FieldType
  implements ControlValueAccessor, OnInit, AfterViewInit
{
  @ViewChild('inp', { static: true }) inp!: ElementRef<HTMLInputElement>;

  private realValue = '';
  private onChange: (v: any) => void = () => {};
  onTouched: () => void = () => {};

  private viewInitialized = false;

  ngOnInit() {
    this.realValue = this.formControl.value
      ? this.formControl.value.toString()
      : '';

    this.formControl.valueChanges.subscribe((value) => {
        if (value !== this.realValue) {
          this.realValue = value ?? '';
          this.render();
        }
      });

    if (this.props.disabled) {
      this.formControl.disable();
    } else {
      this.formControl.enable();
    }
  }

  ngAfterViewInit() {
    this.viewInitialized = true;
    this.render();
  }

  writeValue(value: any): void {
    this.realValue = value ?? '';
    if (this.viewInitialized) {
      this.render();
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    if (this.inp) this.inp.nativeElement.disabled = isDisabled;
  }

  onInput(event: Event) {
    const inputEl = event.target as HTMLInputElement;
    const val = inputEl.value;
    this.realValue = val;
    this.onChange(this.realValue);
    this.render();
  }

  onFocus() {
    if (this.props['unmaskWhileFocused']) {
      this.inp.nativeElement.value = this.realValue;
      this.inp.nativeElement.dataset['prevLen'] = String(this.realValue.length);
    }
  }

  onBlur() {
    this.onTouched();
    this.render();
  }

  private render() {
    if (!this.inp) return;
    const maskChar: string = this.props['maskChar'] ?? '*';
    const shouldMask = this.props['maskIf']?.(this.field) ?? true;

    const display = shouldMask ? maskChar.repeat(3) : this.realValue;

    this.inp.nativeElement.value = display;
    this.inp.nativeElement.dataset['prevLen'] = String(display.length);
  }
}
